import React from "react"
import RaffleHolder from "./RaffleHolder"
import { useRaffle } from "../RaffleContext"
import I18n from "@helper/i18nInstance"
import "./RaffleOver.scss"

const RaffleOver: React.FC = () => {
  const {
    raffle,
  } = useRaffle()
  return <RaffleHolder raffleOver testId="raffle-over">
    <div className="neo__raffleOver">
      <div>
        {I18n.t("raffle.raffle_over_info")}
        {raffle?.meta.current_raffle_url &&
          <>
            {" "}
            <span dangerouslySetInnerHTML={{__html: I18n.t("raffle.link_current_raffle", { current_raffle_url: raffle.meta.current_raffle_url })}} />
          </>}
      </div>
    </div>
  </RaffleHolder>
}

export default RaffleOver
